import React, { Component } from "react";
import t from "i18n";
import { formatAmount } from "../../../../services/utils";
import { CommonLoader } from "../../../common/CommonLoader";

class PaperInscriptionsCAType extends Component {

  formatData = (data) => {
    const result = { individuel: {}, fiduciare: {} };

    for (const month in data) {
      for (const siloId in data[month]) {
        const silo = data[month][siloId];
        const { silotName, individuelNbrInscrit, individuelCa, fiduciareNbrInscrit, fiduciareCa } = silo;

        // Individuel
        if (!result.individuel[silotName]) {
          result.individuel[silotName] = { individuelNbrInscrit: 0, individuelCa: 0 };
        }
        result.individuel[silotName].individuelNbrInscrit += individuelNbrInscrit;
        result.individuel[silotName].individuelCa += individuelCa;

        // Fiduciaire
        if (!result.fiduciare[silotName]) {
          result.fiduciare[silotName] = { fiduciareNbrInscrit: 0, fiduciareCa: 0 };
        }
        result.fiduciare[silotName].fiduciareNbrInscrit += fiduciareNbrInscrit;
        result.fiduciare[silotName].fiduciareCa += fiduciareCa;
      }
    }

    return result;
  };


  render() {
    const { data, handleToggleKey, visibleKeys, silotDataFetch, showCompare, onShowCompareStatsByType, showCompareStats } = this.props;
    const formattedData = this.formatData(data);

    const getTotals = (categoryData, type) => {
      let totalNbr = 0;
      let totalCa = 0;
      Object.values(categoryData).forEach((item) => {
        totalNbr += item[`${type}NbrInscrit`];
        totalCa += item[`${type}Ca`];
      });
      return { totalNbr, totalCa };
    };

    const individuelTotals = getTotals(formattedData.individuel, "individuel");
    const fiduciareTotals = getTotals(formattedData.fiduciare, "fiduciare");

    const totalNbr = individuelTotals.totalNbr + fiduciareTotals.totalNbr;
    const totalCa = individuelTotals.totalCa + fiduciareTotals.totalCa;

    return (
      <div style={{ width: '50%', display: 'flex', flexDirection: 'column', gap: '20px' }}>
        <div style={{
          background: "#F9FAFB",
          padding: "20px",
          borderRadius: "10px",
          width: "100%",
          boxShadow: "0 2px 10px rgba(0,0,0,0.1)"
        }}>
          {silotDataFetch ? <CommonLoader containerHeight={"300px"} iconFontSize={"50px"} iconColor={"#29394D"} /> :
            (
              <React.Fragment>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "4px 0",
                    fontSize: "14px",
                    color: "#29394D",
                  }}
                >
                  <span style={{ width: "45%" }}></span>
                  <span style={{ width: "25%", textAlign: "end" }}>Inscription</span>
                  <span style={{ width: "25%", textAlign: "end" }}>C.A</span>
                  <span style={{ width: "5%" }}></span>
                </div>

                {["individuel", "fiduciare"].map((type) => {
                  const categoryData = formattedData[type];
                  const totals =
                    type === "individuel" ? individuelTotals : fiduciareTotals;
                  const color = type === "individuel" ? "#18A0FB" : "#F47F4D";

                  return (
                    <React.Fragment key={type}>
                      <div style={{ marginTop: "15px", opacity: visibleKeys.includes(type) ? 1 : 0.5 }}>
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                          <div style={{ display: "flex", alignItems: "center", gap: "8px", width: "25%" }}>
                            <span style={{ width: "8px", height: "8px", borderRadius: "40%", backgroundColor: color }}></span>
                            <span style={{ fontWeight: "500", fontSize: "16px", color: "#29394D", textTransform: "capitalize" }}>
                              {type === "individuel" ? "Individuelle" : "Fiduciaire"}
                            </span>
                          </div>
                          {
                            showCompareStats === false
                              ?
                              (
                                <div
                                  style={{ display: "flex", alignItems: "center", gap: "8px", width: "20%", backgroundColor: showCompare[type] ? "#ffffff" : "#29394dff", color: showCompare[type] ? "#29394dff" : "#ffffff", border: "1px solid #29394D", borderRadius: "15px", justifyContent: "center", padding: "4px 8px", cursor: "pointer" }}
                                  onClick={() => onShowCompareStatsByType(type)}
                                >
                                  Compare
                                </div>
                              ) :
                              (
                                <div style={{ display: "flex", alignItems: "center", gap: "8px", width: "20%" }} />
                              )
                          }
                          <span style={{ fontWeight: "500", color: color, width: "25%", textAlign: "end" }}>
                            {totals.totalNbr}
                          </span>
                          <span style={{ fontWeight: "500", color: color, width: "25%", textAlign: "end" }}>
                            {formatAmount(totals.totalCa)}
                          </span>
                          <span
                            style={{ width: "5%", display: "flex", justifyContent: "center", cursor: "pointer" }}
                            onClick={() => handleToggleKey(type)}
                          >
                            {type === 'fiduciare' ? (<img src={visibleKeys.includes('fiduciare') ? "/img/icons/event-stats/eye-2.svg" : "/img/icons/event-stats/eye-1.svg"} alt="" />) : null}
                            {type === 'individuel' ? (<img src={visibleKeys.includes('individuel') ? "/img/icons/event-stats/eye-2.svg" : "/img/icons/event-stats/eye-1.svg"} alt="" />) : null}
                          </span>
                        </div>
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                          <div style={{ display: "flex", alignItems: "center", gap: "8px", width: "45%" }}>
                            <span style={{ fontWeight: "500", fontSize: "14px", color: "#29394D" }}>Prix moyen par achat</span>
                          </div>
                          <span style={{ fontWeight: "500", color: color, width: "50%", textAlign: "end" }}>
                            {formatAmount(totals.totalCa === 0 ? 0 : totals.totalCa / totals.totalNbr)}
                          </span>
                          <span style={{ width: "5%" }} />
                        </div>
                        <div
                          style={{
                            borderTop: "1px solid #29394D",
                            marginTop: "8px",
                            paddingTop: "8px",
                            height: "155px",
                            overflowY: "auto"
                          }}
                        >
                          {Object.entries(categoryData)
                            .sort(([, a], [, b]) => b[`${type}NbrInscrit`] - a[`${type}NbrInscrit`])
                            .map(([siloName, values]) => (
                              <div
                                key={siloName}
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  padding: "10px 0",
                                  fontSize: "14px",
                                  color: "#29394D",
                                  opacity: 1,
                                  borderBottom: "1px solid #D8DDE2",
                                }}
                              >
                                <span style={{ width: "45%" }}>{siloName}</span>
                                <span style={{ width: "25%", textAlign: "end" }}>
                                  {values[`${type}NbrInscrit`]}
                                </span>
                                <span style={{ width: "25%", textAlign: "end" }}>
                                  {formatAmount(values[`${type}Ca`])}
                                </span>
                                <span style={{ width: "5%" }}></span>
                              </div>
                            ))}
                        </div>
                      </div>
                    </React.Fragment>
                  );
                })}

                <div
                  style={{
                    borderTop: "1px solid #29394D",
                    marginTop: "25px",
                    paddingTop: "12px",
                    fontWeight: "700",
                    color: "#29394D",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    fontSize: "16px",
                  }}
                >
                  <span style={{ width: "25%" }}>Total</span>
                  {
                    showCompareStats === false
                      ?
                      (
                        <div
                          style={{ display: "flex", alignItems: "center", gap: "8px", width: "20%", backgroundColor: showCompare.all ? "#ffffff" : "#29394dff", color: showCompare.all ? "#29394dff" : "#ffffff", border: "1px solid #29394D", borderRadius: "15px", justifyContent: "center", padding: "4px 8px", cursor: "pointer" }}
                          onClick={() => onShowCompareStatsByType("all")}
                        >
                          Compare
                        </div>
                      )
                      :
                      (
                        <div
                          style={{ display: "flex", alignItems: "center", gap: "8px", width: "20%" }}
                        />
                      )
                  }
                  <span style={{ width: "25%", textAlign: "end" }}>{totalNbr}</span>
                  <span style={{ width: "25%", textAlign: "end" }}>{formatAmount(totalCa)}</span>
                  <span style={{ width: "5%" }}></span>
                </div>
                <div
                  style={{
                    fontWeight: "500",
                    fontSize: "14px",
                    color: "#29394D",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <span style={{ width: "45%" }}>Prix moyen par achat</span>
                  <span style={{ width: "50%", textAlign: "end" }}>{formatAmount(totalCa === 0 ? 0 : totalCa / totalNbr)}</span>
                  <span style={{ width: "5%" }}></span>
                </div>
              </React.Fragment>
            )}
        </div>
      </div>
    );
  }
}

export default PaperInscriptionsCAType;



// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/EventRegistrantLinechart/PaperInscriptionsCAType.js